module.exports = __webpack_public_path__ + "img/member-icon1-04.cb92e410.png";